export default (theme) => {
  return {
    h1_error__message: {
      color: theme.palette.background.paper,
    },
    grid__item__paddingTB: {
      padding: theme.spacing(5, 0),
    },
  }
}
